import React, {useEffect } from "react";
import "./SubStyle.css"


// Section two features start  //
const features = [
  {
    number: "01",
    title: "Experienced care leadership",
    text: "Visible, accountable leadership from seasoned care-sector operators.",
  },
  {
    number: "02",
    title: "Governance and compliance",
    text: "Robust systems that keep quality, safety and CQC readiness at the centre.",
  },
  {
    number: "03",
    title: "Workforce optimisation",
    text: "A stable, capable workforce with the right deployment, culture and support.",
  },
  {
    number: "04",
    title: "Financial performance",
    text: "Commercial discipline that strengthens occupancy, efficiency and long-term value.",
  },
];




const features2 = [
  [
    "Full operational responsibility",
    "Interim and turnaround management",
  ],
  [
    "CQC readiness and quality improvement",
    "Registered manager and leadership support",
  ],
  [
    "Workforce planning and agency reduction",
    "Occupancy, referrals and fee strategy",
  ],
  [
    "Financial controls and performance reporting",
    "Systems, policies and governance implementation",
  ],
];

const steps = [
  {
    number: "01",
    title: "Understand",
    description:
      "Review the service, people, systems, compliance and finances to establish a clear baseline.",
  },
  {
    number: "02",
    title: "Stabilise",
    description:
      "Take control of immediate risks, clarify accountability and introduce an effective operating rhythm.",
  },
  {
    number: "03",
    title: "Improve",
    description:
      "Deliver a focused plan that strengthens care quality, workforce, occupancy and profitability.",
  },
  {
    number: "04",
    title: "Sustain",
    description:
      "Embed capable leaders, transparent reporting and systems that make better performance last.",
  },
];

 const cards = [
    {
      id: 1,
      subtitle: "FOR OWNERS AND OPERATORS",
      title: (
        <>
          More control, stronger
          <br />
          teams and better outcomes
        </>
      ),
      description:
        "Gain experienced operational leadership without losing sight of your values, ambitions or residents.",
      className: "light-card",
    },
    {
      id: 2,
      subtitle: "FOR INVESTORS AND LENDERS",
      title: (
        <>
          Protect value through
          <br />
          expert oversight
        </>
      ),
      description:
        "Improve visibility, manage risk and create a credible path from acquisition or underperformance to sustainable value.",
      className: "dark-card",
    },
  ];


// Section two features End //


const Opera_fullManag = () => {

  
        // open page on top //
         useEffect(() => {
            window.scrollTo(0, 0);
          }, []);
        
          // open page on top // 


  return (
    <>
      <section className="Management">
      <div className="Management-container">

        {/* Left Content */}
        <div className="Management-content">

          <span className="Management-tag">
            OPERATIONAL MANAGEMENT
          </span>

          <h1>Expert operational management for stronger care businesses </h1>

          <p>
            We operate care homes on behalf of owners, investors and
            operators—strengthening governance, improving performance and
            building sustainable, high-quality services.
          </p>

          <div className="Management-buttons">
            <button className="btn btn-primary">
               <a href="#cta-Contact">
                    Book an operational review
                  </a>
             
            </button>

            <button className="btn-outline" href="#Approach">
                <a href="#Approach"> Explore our approach</a>
             
            </button>
          </div>

            <div className="Management-features">
            <span>Hands-on leadership</span>
            <span>•</span>
            <span>CQC-focused governance</span>
            <span>•</span>
            <span>Commercial discipline</span>
          </div>

        </div>

        {/* Right Image */}
        <div className="Management-image">

          <img
           src="https://total-care-operational-management.pearly-berry-5056.chatgpt.site/tca-operational-management-hero.png"
            alt="Operational Management"
          />

          <div className="image-card">

            <span className="sort-card-title">
              OPERATIONAL CLARITY
            </span>

            <h4>
              From boardroom
              <br />
              to care floor
            </h4>

          </div>

        </div>

      </div>

      <div className="shape"></div>
      <div className="Management-indicator">
              <div className="mouse-Management">
                <span className="wheel-Management"></span>
              </div>
              <span className="Management-text">Scroll Down</span>
      </div>

      </section>
      <section className="operational-section">

      {/* Top Cards */}
      <div className="operational-grid">
        {features.map((item) => (
          <div className="operational-card" key={item.number}>
            <span className="operational-number">{item.number}</span>

            <div>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bottom Content */}
      <div className="operation-content">
        <div className="left-content">
          <span className="subtitle">
            COMPLETE OPERATIONAL OVERSIGHT
          </span>

          <h1>
            Operational grip.
            Lasting
            improvement.
          </h1>
        </div>
        <div className="right-content">
          <h2>
            We take full operational responsibility—bringing clarity,
            consistency and control to every aspect of care-home
            performance.
          </h2>

          <p>
            Whether a service needs stabilising, turning around or scaling,
            our team works inside the operation. We align care quality and
            commercial performance so neither is improved at the expense of
            the other.
          </p>
        </div>
        </div>
        <div className="operation-content">
         <div className="right-content">
          <h2>We work alongside care providers as a trusted operating partner,
             delivering tailored solutions for compliance workforce</h2>
          <p>
           Running a successful care business requires more than delivering exceptional 
           care—it demands strong leadership, regulatory compliance, efficient workforce
            management, financial stability, and streamlined day-to-day operations. 
            At Total Care Advisory, we become an extension of your team, providing 
            comprehensive operational support that helps your organisation thrive in
             an ever-changing healthcare landscape.
          </p>
        </div>
         <div className="left-content">
          <span className="subtitle">
           WHAT WE MANAGE
          </span>

          <h1>
           A complete operating partner for care businesses
          </h1>
        </div>
       
      </div>

    </section>

     <section className="features-section">
      <div className="features-container">
        {features2.map((item, index) => (
          <div className="feature-row" key={index}>
            <div className="feature-item">
              <div className="check-icon">✓</div>
              <span>{item[0]}</span>
            </div>

            <div className="feature-item">
              <div className="check-icon">✓</div>
              <span>{item[1]}</span>
            </div>
          </div>
        ))}
      </div>
    </section>

     <section className="approach" id="Approach">
      <div className="approach-container">
        <div className="approach-top">
          <span className="approach-label">OUR APPROACH</span>

          <h2 className="approach-heading">
            Structured enough to measure.
            <br />
            Practical enough to work.
          </h2>
        </div>

        <div className="approach-grid">
          {steps.map((item) => (
            <div className="approach-card" key={item.number}>
              <span className="step-number">{item.number}</span>

              <h3>{item.title}</h3>

              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

     <section className="leadership-section" id="leadership-section">
      <div className="leadership-container">
        {cards.map((card) => (
          <div key={card.id} className={`leadership-card ${card.className}`}>
            <span className="card-subtitle">{card.subtitle}</span>

            <h2 className="card-title">{card.title}</h2>

            <p className="card-description">{card.description}</p>
          </div>
        ))}
      </div>
    </section>

      <section className="contact-cta" id="cta-Contact">
      <div className="contact-containers">
        <div className="contact-content">
          <span className="contact-subtitle">
            START A CONFIDENTIAL CONVERSATION
          </span>

          <h2 className="contact-title">
            Let’s strengthen your care business.
          </h2>

          <p className="contact-description">
            Tell us where the pressure is. We’ll help you understand the
            priorities and the right level of operational support.
          </p>
        </div>

        <div className="contact-btn-wrapper">
          <button className="contact-btn">
                  <a href="tel:+4416033203325">
                     Book an operational review
                  </a>
          </button>
        </div>
      </div>
    </section>
     </>
  )
}

export default Opera_fullManag
